'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { TextField } from '../TextField/index.js';
import { Dropdown } from '../Dropdown/index.js';
import { TextPassage } from '../TextPassage/index.js';
export const Autocomplete = (_a) => {
    var _b;
    var { value, defaultValue, className, label, placeholder, fieldNote, isError, data, custom, children, revealOnFocus, searchAnywhere, onBlur: onParentBlur, onFocus: onParentFocus, onSelectText: onParentSelectText, onInternalValueChange: onParentInternalValueChange, clearCustomValuesOnBlur = true } = _a, other = __rest(_a, ["value", "defaultValue", "className", "label", "placeholder", "fieldNote", "isError", "data", "custom", "children", "revealOnFocus", "searchAnywhere", "onBlur", "onFocus", "onSelectText", "onInternalValueChange", "clearCustomValuesOnBlur"]);
    const componentClassName = classnames('sparky-c-autocomplete', className, {});
    const sortedData = React.useMemo(() => data === null || data === void 0 ? void 0 : data.sort(), [data]);
    const [isTyping, setIsTyping] = React.useState(false);
    const [isFocused, setIsFocused] = React.useState(false);
    const [suggestions, setSuggestions] = React.useState(sortedData);
    const [internalValue, setInternalValue] = React.useState((_b = value !== null && value !== void 0 ? value : defaultValue) !== null && _b !== void 0 ? _b : '');
    const prevInternalValueRef = React.useRef(internalValue);
    const isInternalValueCustomRef = React.useRef(true);
    React.useEffect(() => {
        const isControlled = value !== undefined;
        if (isControlled) {
            setInternalValue(value);
            prevInternalValueRef.current = value;
            isInternalValueCustomRef.current = true;
        }
    }, [value]);
    React.useEffect(() => {
        setSuggestions(sortedData !== null && sortedData !== void 0 ? sortedData : []);
    }, [sortedData]);
    const onChangeText = (ev) => {
        const value = ev.target.value;
        if (prevInternalValueRef.current === value) {
            isInternalValueCustomRef.current = true;
        }
        else {
            isInternalValueCustomRef.current = false;
        }
        setInternalValue(value);
        onParentInternalValueChange === null || onParentInternalValueChange === void 0 ? void 0 : onParentInternalValueChange(value);
        if (value.length >= 1) {
            setIsTyping(true);
        }
        else {
            setIsTyping(false);
        }
        const regex = new RegExp(searchAnywhere ? `${value}` : `^${value}`, `i`);
        if (ev.nativeEvent.inputType === 'deleteContentBackward') {
            if (value.length === 0) {
                setSuggestions(sortedData);
            }
            else {
                setSuggestions(sortedData === null || sortedData === void 0 ? void 0 : sortedData.filter((v) => regex.test(v)).filter((i) => regex.test(i)));
            }
        }
        else {
            setSuggestions(suggestions === null || suggestions === void 0 ? void 0 : suggestions.filter((v) => regex.test(v)).filter((i) => regex.test(i)));
        }
    };
    const selectValue = (value) => {
        prevInternalValueRef.current = value;
        isInternalValueCustomRef.current = true;
        setInternalValue(value);
        onParentSelectText === null || onParentSelectText === void 0 ? void 0 : onParentSelectText(value);
    };
    const onInputFocus = (e) => {
        onParentFocus === null || onParentFocus === void 0 ? void 0 : onParentFocus(e);
        setIsFocused(true);
    };
    const onInputBlur = (e) => {
        setTimeout(() => {
            if (clearCustomValuesOnBlur && !isInternalValueCustomRef.current) {
                setInternalValue('');
                onParentSelectText === null || onParentSelectText === void 0 ? void 0 : onParentSelectText('');
            }
            onParentBlur === null || onParentBlur === void 0 ? void 0 : onParentBlur(e);
            setIsFocused(false);
            setIsTyping(false);
            setSuggestions(sortedData);
        }, 200);
    };
    const searchTermRegex = new RegExp(`(${internalValue &&
        internalValue.replace(/[.\\+*?[^\]$(){}=!<>|:-]/g, '\\$&')})`, 'gi');
    const getBoldFilteredText = (text, term) => {
        const substrings = text.split(searchTermRegex);
        return (_jsx(TextPassage, Object.assign({ className: "sparky-c-autocomplete__options", onClick: () => selectValue(text) }, { children: substrings.map((substring, index) => substring.toLowerCase() === (term === null || term === void 0 ? void 0 : term.toLowerCase()) ? (_jsx("strong", { children: substring }, index)) : (_jsx("span", { children: substring }, index))) }), text));
    };
    const showSuggestions = isTyping || (revealOnFocus && isFocused);
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { children: [_jsx(TextField, { value: internalValue, defaultValue: defaultValue, label: label, placeholder: placeholder, fieldNote: fieldNote, isError: isError, onFocus: onInputFocus, onBlur: onInputBlur, onChange: onChangeText }), showSuggestions && (_jsx(Dropdown, Object.assign({ className: "sparky-c-autocomplete__dropdown" }, { children: custom
                    ? children
                    : isTyping
                        ? suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((text) => getBoldFilteredText(text, internalValue))
                        : suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((text, index) => (_jsx(TextPassage, Object.assign({ className: "sparky-c-autocomplete__options", onClick: () => selectValue(text) }, { children: text === internalValue ? _jsx("strong", { children: text }) : text }), index))) })))] })));
};
//# sourceMappingURL=Autocomplete.js.map